import * as Utils from 'Assets/Utils'

import ClientHttpRequest from "Api/ClientHttpRequest"
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import {isLoading} from "Modules/Loading"
import { post } from "axios";

const initialState = Immutable.Map({})
	.set('Search', new Immutable.List([]))
	.set('Response', new Immutable.Map({}))
    .set('Response', new Immutable.Map({}))
	.set('Get', new Immutable.Map({}))
    .set('GetDoc', new Immutable.Map({}))
	.set('GetExists', new Immutable.Map({}))
	.set('GetDocById', new Immutable.Map({}))

/* Types */
export const SAVE_FILE = "SAVE_FILE";
export const ACTION_GET_CONF_PLD = 'ACTION_GET_CONF_PLD'
export const ACTION_UPDATE_CONF_PLD = 'ACTION_UPDATE_CONF_PLD'
export const ACTION_GET_PLD_DOCUMENT = 'ACTION_GET_PLD_DOCUMENT'
export const ACTION_UPDATE_PLD_DOCUMENT = 'ACTION_UPDATE_PLD_DOCUMENT'
export const ACTION_DELETE_PLD_DOCUMENT = 'ACTION_DELETE_PLD_DOCUMENT'
export const ACTION_SEARCH_PLD_DOCUMENTS = 'ACTION_SEARCH_PLD_DOCUMENTS'
export const ACTION_GET_EXISTS_COMPROBANTE = 'ACTION_GET_EXISTS_COMPROBANTE'
export const ACTION_GET_PLD_DOCUMENTBYID = 'ACTION_GET_PLD_DOCUMENTBYID'

/* Reducer */
export default (state = initialState, action) => {
	switch (action.type) {
		case ACTION_SEARCH_PLD_DOCUMENTS:
			return state.set('Search', new Immutable.List(action.Obj))
		case ACTION_GET_CONF_PLD:
			return state.set('Get', new Immutable.Map(action.Obj))
		case SAVE_FILE:
				return state.set("Response", new Immutable.Map(action.Obj));
		case ACTION_UPDATE_CONF_PLD:
			return state.set('Response', new Immutable.Map(action.Obj))
		case ACTION_GET_PLD_DOCUMENT:
			return state.set('GetDoc', new Immutable.Map(action.Obj))
        case ACTION_UPDATE_PLD_DOCUMENT:
			return state.set('Response', new Immutable.Map(action.Obj))
        case ACTION_DELETE_PLD_DOCUMENT:
			return state.set('Response', new Immutable.Map(action.Obj))
		case ACTION_GET_EXISTS_COMPROBANTE:
			return state.set('GetExists', new Immutable.Map(action.Obj))
		case ACTION_GET_PLD_DOCUMENTBYID:
			return state.set('GetDocById', new Immutable.Map(action.Obj))
		default:
			return state;
	}
};

/* Action Creators */

export const addPldDocument = (form) => {
	const headers={
		"Content-Type": "multipart/form-data",
		Authorization: sessionStorage.access_token,
		uid: sessionStorage.uid
	}

	if (localStorage.type == 'Donataria') {
		headers.idDonataria = localStorage.idDonataria || ''
	}

	return (dispatch) => {
		dispatch(isLoading(true))

		return post("/api/addPldDocument", form, { headers })
		.then(response => {
				dispatch(isLoading(false))
				dispatch(createModal(Utils.successMessage()))
				return response.data;
			}).catch(error => {
				dispatch(isLoading(false))
				dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data)))
				);
				throw error
			})
	}
}

export const getDocumentById = (id) => {
	const headers = {
		Authorization: sessionStorage.access_token,
		uid: sessionStorage.uid,
		responseType: 'arraybuffer',
	}

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/getDocumentById',
			method: "POST",
			data: { id },
			headers: headers,
		}).request().then(response => {
			dispatch(isLoading(false))
			response.data = Utils.conver_(response.data['documento']);
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}



export const searchPldDocuments = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/searchPldDocuments',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_SEARCH_PLD_DOCUMENTS, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getPldDocument = (id) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/getPldDocument',
			method: "POST",
			data: { id },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_GET_PLD_DOCUMENT, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getPldDonataria = (idDonataria) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/pldDonataria',
			method: "POST",
			data: { ...idDonataria },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_GET_EXISTS_COMPROBANTE, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			throw error
		})
	}
}

export const updatePldDocument = (form) => {
	const headers={
		"Content-Type": "multipart/form-data",
		Authorization: sessionStorage.access_token,
		uid: sessionStorage.uid
	}

	if (localStorage.type == 'Donataria') {
		headers.idDonataria = localStorage.idDonataria || ''
	}

	return (dispatch) => {
		dispatch(isLoading(true))

		return post("/api/updatePldDocument", form, { headers })
		.then(response => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.successMessage()))
			return response.data;
			}).catch(error => {
				dispatch(isLoading(false))
				dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data)))
				);
				throw error
			})
	}
}


export const deletePldDocument = (id) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/deletePldDocument',
			method: "POST",
			data: { id },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_DELETE_PLD_DOCUMENT, Obj: response.data })
			dispatch(createModal(Utils.successMessage()))
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getConfPld = (id) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/getConfPld',
			method: "POST",
			data: { id },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_GET_CONF_PLD, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const updateConfPld = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/updateConfPld',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_UPDATE_CONF_PLD, Obj: response.data })
			dispatch(createModal(Utils.successMessage()))
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const clearPLDDocuments = () => {
	return (dispatch) => {
		dispatch({ type: ACTION_GET_PLD_DOCUMENT, Obj: {} })
		dispatch({ type: ACTION_SEARCH_PLD_DOCUMENTS, Obj: [] })
	}
}

export const clearConfPld = () => {
	return (dispatch) => {
		dispatch({ type: ACTION_GET_CONF_PLD, Obj: {
			activarPld: 0,
			montoMinimoActivacion: 0,
			diasActivacion: 0
		} })
	}
}


// WEBPACK FOOTER //
// ./src/modules/Configurations/PLD/ConfPld.js